import { render, staticRenderFns } from "./productOrderHeaderInfo.vue?vue&type=template&id=c6445864&scoped=true&"
import script from "./productOrderHeaderInfo.vue?vue&type=script&lang=js&"
export * from "./productOrderHeaderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6445864",
  null
  
)

export default component.exports